import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { getOrigin } from 'owa-url';
import { trace } from 'owa-trace';

export default async function makeCardActionServiceCall(
    url: string,
    body: string,
    requestType: string
) {
    let headers = new Headers();
    let [token, tokenPromise] = getAccessTokenforResourceAsLazy(getOrigin());
    // If token is not returned synchronously, we need to await on the tokenPromise
    if (!token) {
        token = await tokenPromise;
    }

    headers.append('authorization', 'Bearer  ${token}');
    const request: RequestInit = {
        method: requestType,
        headers: headers,
        body: body,
    };
    return fetch(url, request).catch(error => {
        // add retry
        trace.warn('Failed to make an api call triggered from hero action' + error.message);
    });
}
